import { requestTokenRefresh } from "~auth/useAccessToken.ts";
import { ApiError } from "~generated";

const MAX_QUERY_RETRIES = 3;

export function defaultRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status === 401) {
    // the server rejected a token msal still considers valid; the retry then fetches a fresh one
    requestTokenRefresh();
  }
  return failureCount < MAX_QUERY_RETRIES;
}
